// core version + navigation, pagination modules:
import Swiper, { Pagination, Navigation } from "swiper";

const productTabs = document.querySelectorAll(".product-filter-tab");

export function productsCarousel() {
    Swiper.use([Pagination, Navigation]);

    // init Swiper:
    const productSwiper = new Swiper(".product-swiper", {
        // Optional parameters
        slidesPerView: 1,
        centeredSlides: true,

        // If we need pagination
        //pagination: {
        //    el: ".swiper-pagination",
        //    clickable: true,
        //},
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 20,
                centeredSlides: true,
            },
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 0,
                centeredSlides: false,
            },
            1024: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 0,
                centeredSlides: false,
            },
        },
    });

    if (productTabs) {
        productTabs.forEach((item) => {
            item.addEventListener("click", (event) => {
                productSwiper.slideTo(0, 1, false);
            });
        });
    }
}
